// extracted by mini-css-extract-plugin
export default {"checkIcon":"styles_checkIcon__78LGd"};